export const testimonials = [
  {
    id: '1',
    name: 'Ana Carla Silva',
    role: 'Cliente desde 2022',
    rating: 5,
    text: 'Simplesmente os melhores sanduíches naturais de Fortaleza! A qualidade dos ingredientes é perceptível na primeira mordida. Super práticos para o dia a dia corrido.',
  },
  {
    id: '2',
    name: 'Ricardo Menezes',
    role: 'Dono de Cafeteria',
    rating: 5,
    text: 'Revendo os produtos da Naturalle há mais de um ano na minha cafeteria. Meus clientes adoram! A entrega é sempre pontual e os produtos chegam impecáveis.',
  },
  {
    id: '3',
    name: 'Juliana Costa',
    role: 'Nutricionista',
    rating: 5,
    text: 'Como nutricionista, recomendo a Naturalle para meus pacientes. Ingredientes de verdade, sem conservantes artificiais e um sabor que surpreende. Finalmente uma opção prática e saudável.',
  },
  {
    id: '4',
    name: 'Marcos Oliveira',
    role: 'Cliente desde 2023',
    rating: 5,
    text: 'Peço toda semana! O sanduíche de frango com requeijão é meu favorito. Prático, saboroso e me ajuda a manter a alimentação saudável mesmo na correria.',
  },
  {
    id: '5',
    name: 'Fernanda Albuquerque',
    role: 'Gerente de Academia',
    rating: 5,
    text: 'Começamos a revender na nossa academia e foi um sucesso! Nossos alunos amam ter uma opção saudável e prática pós-treino. Parceria que deu muito certo.',
  },
  {
    id: '6',
    name: 'Pedro Henrique',
    role: 'Cliente desde 2021',
    rating: 5,
    text: 'O atendimento é incrível e os sanduíches são uma delícia. Dá pra sentir que é feito com carinho e ingredientes de qualidade. Já indiquei pra vários amigos!',
  },
];